import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Keeps <html lang="…"> in sync with the current i18next language.
 */
export function useHtmlLang() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.language ?? "de";
    // Use the base language for the html lang attribute (e.g. "de" for "de-CH", "nl" for "nl-BE")
    const htmlLang = lang.includes("-") ? lang : lang;
    document.documentElement.lang = htmlLang;
  }, [i18n.language]);
}
